export const toastStyle = {
    style: {
        fontSize: '13px',
        borderRadius: '15px',
        background: '#333',
        color: '#fff',
    },
}